export default __webpack_public_path__ + "static/media/img3.739da450.png";